import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';

/**
 * Dieses Binding versucht das automatische Füllen von Felder durch den Browser zu unterbinden
 * Da hier keine zuverlässige Möglichkeit dokumentiert ist, wird in diesem Binding das jeweilige Element
 * disabled und 200ms nachdem die View fertig gerendert wurde, wieder enabled. Somit ist das Eingabefeld
 * während des Zeitpunkts des AutoFill gesperrt und der Browser kann das Feld nicht befüllen
 *
 * Dieses Binding unterbindet nicht die AutoComplete-Vorschläge des Browsers!
 */
export default class PreventAutoFillBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.preventAutoFill = {
            init: (node: HTMLInputElement, valueAccessor: () => any) => {

                const values = valueAccessor();
                const $element = $(node) as JQuery<HTMLInputElement>;
                const isEnabled: KnockoutObservable<boolean> = values.isEnabled;
                if (!isEnabled())
                    return;
                
                $element.attr('autocomplete', 'off');
            }
        };
    }
}